<div class="container">
  @if (patientImportData) {
    <div class="patient-card">
      <lib-matchsync-smart-pi
        [patientData]=patientImportData.patientData
        [oktaToken]=patientImportData.oktaToken
        [apiURL]=patientImportData.apiURL
        [epicAuthToken]=patientImportData.epicAuthToken
        [issURL]=patientImportData.issURL
        />
    </div>
  }
</div>